import { NbMenuItem } from '@nebular/theme';
import { PermissionKey } from '@drl/core/auth/permission-key.enum';
import { FontPack } from '@drl/core/enums';
import { TranslateService } from '@ngx-translate/core';

export const menuItem = (translate: TranslateService): NbMenuItem[] => {
  return [
    // {
    //   title: translate.instant('dashboardLeftMenuLbl'),
    //   icon: {icon: 'home-lg-alt', pack: FontPack.FontAwesomeSolid},
    //   link: '/main/home',
    //   home: true,
    //   data: {
    //     permission: '*',

    //   },
    // },
    {
      title: translate.instant('careCentralLeftMenuLbl'),
      // icon: {icon: 'hands-heart', pack: FontPack.FontAwesomeSolid},
      icon: { icon: 'care-central', pack: 'custom' },
      link: '/main/care-central',
      home: true,
      data: {
        permission: PermissionKey.CanSeeCareCentral,
      },
    },
    {
      title: translate.instant('patientLeftMenuLbl'),
      // icon: {icon: 'users', pack: FontPack.FontAwesomeSolid},
      icon: { icon: 'patient-directory', pack: 'custom' },
      link: '/main/patients',
      home: false,
      data: {
        permission: PermissionKey.ViewPatient,
      },
    },
    // {
    //   title: translate.instant('onlineAppointment'),
    //   icon: {icon: 'calendar-check', pack: FontPack.FontAwesomeSolid},
    //   link: '/main/online-appoinments',
    //   home: false,
    //   data: {
    //     permission: PermissionKey.ViewPatient,
    //   },
    // },
    {
      title: translate.instant('patientEducationLeftMenuLbl'),
      // icon: {icon: 'book', pack: FontPack.FontAwesomeSolid},
      icon: { icon: 'patient-education', pack: 'custom' },
      link: '/main/cms',
      home: false,
      data: {
        permission: PermissionKey.ViewCMSContent,
      },
      expanded: false,
      children: [
        {
          title: translate.instant('publiashedPostLeftMenuLbl'),
          icon: { icon: 'book-open', pack: FontPack.FontAwesomeSolid },
          link: '/main/cms/posts',
          data: {
            permission: [PermissionKey.ViewCMSContent],
          },
          expanded: true,
        },
        {
          title: translate.instant('publiashedGalleryLeftMenuLbl'),
          icon: { icon: 'album-collection', pack: FontPack.FontAwesomeSolid },
          link: '/main/cms/galleries',
          data: {
            permission: [PermissionKey.ViewCMSContent],
          },
          expanded: true,
        },
      ],
    },
    // {
    //   title: translate.instant('dietPlanLeftMenuLbl'),
    //   icon: {icon: 'apple-alt', pack: FontPack.FontAwesomeSolid},
    //   link: '/main/diet-plans',
    //   home: false,
    //   data: {
    //     permission: PermissionKey.ViewDietPlan,
    //   },
    //   hidden: true
    // },
    {
      title: translate.instant('userManagementLeftMenuLbl'),
      // icon: {icon: 'user-friends', pack: FontPack.FontAwesomeSolid},
      icon: { icon: 'user-management-settings', pack: 'custom' },
      data: {
        permission: [PermissionKey.ViewUserManagement],
      },
      expanded: false,
      children: [
        {
          title: translate.instant('userLeftMenuLbl'),
          icon: { icon: 'user', pack: FontPack.FontAwesomeSolid },
          link: '/main/users',
          data: {
            permission: PermissionKey.ViewAnyUser,
          },
        },
        // {
        //   title: translate.instant('careGroupsLeftMenuLbl'),
        //   icon: {icon: 'hand-holding-heart', pack: FontPack.FontAwesomeSolid},
        //   link: '/main/care-groups',
        //   data: {
        //     permission: PermissionKey.ViewCareGroup,
        //   },
        // },
      ],
    },
    // {
    //   title: translate.instant('configurationsLeftMenuLbl'),
    //   icon: {icon: 'sliders-h-square', pack: FontPack.FontAwesomeSolid},
    //   data: {
    //     permission: PermissionKey.ManageOwnTenantConfig,
    //   },
    //   expanded: false,
    //   children: [
    //     {
    //       title: translate.instant('alertsLeftMenuLbl'),
    //       icon: {icon: 'bell', pack: FontPack.FontAwesomeSolid},
    //       link: '/main/configurations/alerts',
    //       data: {
    //         permission: PermissionKey.UpdateAlertConfig,
    //       },
    //     },
    //     {
    //       title: translate.instant('surveyLeftMenuLbl'),
    //       icon: {icon: 'clipboard-check', pack: FontPack.FontAwesomeSolid},
    //       link: '/main/configurations/surveys',
    //       data: {
    //         permission: PermissionKey.UpdateSurvey,
    //       },
    //     },
    //     {
    //       title: translate.instant('generalLeftMenuLbl'),
    //       icon: {icon: 'users-cog', pack: FontPack.FontAwesomeSolid},
    //       link: '/main/configurations/general',
    //       data: {
    //         permission: '*',
    //       },
    //     },
    //     {
    //       title: translate.instant('officeDetailsLeftMenuLbl'),
    //       icon: {icon: 'clock', pack: FontPack.FontAwesomeSolid},
    //       link: '/main/configurations/office-details',
    //       data: {
    //         permission: '*',
    //       },
    //     },
    //   ],
    // },
    {
      title: translate.instant('reportsLeftMenuLbl'),
      icon: { icon: 'file-alt', pack: FontPack.FontAwesomeSolid },
      link: '/main/reports',
      home: true,
      data: {
        permission: '*',
      },
    },
  ];
};
